import { dynamicImport } from '@core/helpers'
import { getCountryConfig } from '@core/helpers/countries'
import { ROUTES } from '@router'

export default ({ country, config }) => {
  const countryConfig = getCountryConfig(country)
  const reviewsProductLandingRegex =
    countryConfig.routesValidation.reviewsProductLanding
  const merchantNameSpace = countryConfig.routesValidation.shop

  const useNewUrl = config.FF_NEW_URL_FORMAT.includes(country)

  return [
    // Review form
    {
      path: '/review/:id',
      name: ROUTES.REVIEWS.FORM,
      component: () =>
        dynamicImport(
          import('@internal-reviews/components/Form/ConnectedForm'),
        ),
    },
    // Review pages
    {
      path: useNewUrl
        ? '/r/l/:landingSlug/:landingId'
        : `/:landingSlug(${reviewsProductLandingRegex})/reviews`,
      name: ROUTES.REVIEWS.PAGES.LANDING,
      component: () =>
        dynamicImport(
          import('@internal-reviews/components/Page/ConnectedPage'),
        ),
    },
    {
      // Have to keep a variable here because the param `sellerPrefix` is used
      // TODO: Remove it
      path: useNewUrl
        ? '/r/s/:sellerSlug/:sellerId'
        : `/:sellerPrefix(${merchantNameSpace})/:sellerSlug/reviews`,
      component: () =>
        dynamicImport(
          import('@internal-reviews/components/Page/ConnectedPage'),
        ),
      name: ROUTES.REVIEWS.PAGES.MERCHANT,
    },
    {
      path: useNewUrl ? '/r/p/:productId' : '/reviews/product/:productId',
      component: () =>
        dynamicImport(
          import('@internal-reviews/components/Page/ConnectedPage'),
        ),
      name: ROUTES.REVIEWS.PAGES.PRODUCT,
    },
    {
      path: useNewUrl ? '/r' : '/reviews',
      name: ROUTES.REVIEWS.PAGES.ALL,
      component: () =>
        dynamicImport(
          import('@internal-reviews/components/Page/ConnectedPage'),
        ),
    },
  ]
}
